import React from "react";
import PropTypes from "prop-types";
import ScoringGridComponent from "./ScoringGridComponent";

export const ScoringComponent = ({
  scoringGrid,
  scoringGridLoaded,
  scoringGridExpanded,
  dimensionPeriods,
  onScoringGridExpand
}) => {
  return (
    <>
      {scoringGridLoaded && (
        <ScoringGridComponent
          scoringGrid={scoringGrid}
          dimensionPeriods={dimensionPeriods}
          cardExpanded={scoringGridExpanded}
          onExpand={onScoringGridExpand}
        />
      )}
    </>
  );
};

ScoringComponent.propTypes = {
  scoringGrid: PropTypes.object.isRequired,
  dimensionPeriods: PropTypes.array,
  scoringGridExpanded: PropTypes.bool.isRequired,
  onScoringGridExpand: PropTypes.func,
  scoringGridLoaded: PropTypes.bool
};

export default ScoringComponent;
